import React, {useState, useEffect, useCallback} from 'react'
import {useDispatch} from 'react-redux'

import BASELoading from "../../../../../../../@BASE/core/BASELoading";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import BASESvgIcon from "../../../../../../../@BASE/core/BASESvgIcon";
import Instructions from "../components/Instructions";

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import { getInstance } from "../../../../../../actions";

export default function AssessmentReadingMC(props) {
  const { data, dir, ins = [], course, comments = [] } = props;
  const tl = `${dir === "rtl" ? "text-18" : "text-14"} ${course?.language?.acronym}`.trim();

  const dispatch = useDispatch();
  const [isFetched, setIsFetched] = useState(false);
  const [materialPage, setMaterialPage] = useState();

  if (!data) {
    return <BASELoading />;
  }

  const getMaterialPage = useCallback(
    async (page_id) => {
      try {
        const response = await dispatch(getInstance("pages")(page_id)).unwrap();
        return response;
      } catch (error) {
        console.error("Failed to fetch lesson pages:", error);
        return null;
      }
    },
    [dispatch] // Memoizing the function to prevent re-creation
  );

  useEffect(() => {
    if (!data.media_page_id || isFetched) return;
  
    setIsFetched(true);
  
    const fetchPage = async () => {
      const page = await getMaterialPage(data.media_page_id);
      if (page) {
        setMaterialPage(page); // wrap in array if your state expects an array
      }
    };
  
    fetchPage();
  }, [data.media_page_id, getMaterialPage, isFetched]);

  // filer comments by component_id
  const componentCommentsCount = (component) => {
    return comments.filter(
      (comment) =>
        comment.component === component && comment.internality !== true
    ).length;
  };

  fetch

  return (
    <div>
      <style>
        {`
          .wysiwyg p {
            margin: 0px;
          }
        `}
      </style>

      <Instructions
        ins={ins}
        course={course}
        dir={dir}
        tl={tl}
        componentCommentsCount={componentCommentsCount}
      />

      <Typography className="text-16 font-bold p-16 pb-0">
        Page Content:
      </Typography>

      <Typography className="text-14 font-bold p-16 pb-0">Materials</Typography>
      <Paper elevation={0} variant="outlined" square className="p-16 m-16">
        <Grid container spacing={0}>
          <Grid item xs={12}>
            <Typography className="text-14 font-bold m-0">
              Authentic Material:
            </Typography>
            <Divider className="my-16" />
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={0}>
              <Grid item xs={12} sm={4} lg={2}>
                <Typography className="text-14 font-semibold m-0">
                  Title (TL):
                </Typography>
              </Grid>
              <Grid item xs={12} sm={8} lg={10}>
                <Typography className={`${tl} m-0`} dir={dir}>
                  {data.reading_title_tl}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={4} lg={2}>
                <Typography className="text-14 font-semibold m-0">
                  Title (EN):
                </Typography>
              </Grid>
              <Grid item xs={12} sm={8} lg={10}>
                <Typography className="text-14 m-0">
                  {data.reading_title_en}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={4} lg={2}>
                <Typography className="text-14 font-semibold m-0">
                  Source URL:
                </Typography>
              </Grid>
              <Grid item xs={12} sm={8} lg={10}>
                <Typography className="text-14 m-0">
                  {data.source_url}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={4} lg={2}>
                <Typography className="text-14 font-semibold m-0">
                  Material location:
                </Typography>
              </Grid>
              <Grid item xs={12} sm={8} lg={10}>
                <Typography className="text-14 m-0">
                  {data.material_location}
                </Typography>
              </Grid>
              {materialPage && (
                <Grid item xs={12}>
                  <Divider className="my-16" />
                  <Accordion className="w-full shadow-none">
                    <AccordionSummary
                      className="p-0"
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="material-content"
                      id="material-header"
                      square
                    >
                      <Typography component="span">Reading</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography className={`${tl} m-0 wysiwyg`} dir={dir} dangerouslySetInnerHTML={{ __html: materialPage.content.core.display_content }} />
                    </AccordionDetails>
                  </Accordion>
                </Grid>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Paper>

      <Paper elevation={0} variant="outlined" square className="m-16">
        <Paper elevation={0} variant="outlined" square className="p-16 m-16">
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Typography className="text-14 font-bold m-0">
                Question:
              </Typography>
              <Divider className="my-16" />
            </Grid>
            <Grid item xs={12}>
              <Typography className={`${tl} m-0`} dir={dir}>
                {data.question.prompt}
              </Typography>
            </Grid>
            {/* <Grid item xs={12} container spacing={0}>
              <Grid item xs={2}>
                <Typography className="text-14 font-semibold m-0">
                  Paragraph Number:
                </Typography>
              </Grid>
              <Grid item xs>
                <Typography className="text-14 m-0">
                  {data.question.para_num}
                </Typography>
              </Grid>
            </Grid>
            {data.question.pdf_page && (
              <Grid item xs={12} container spacing={0}>
                <Grid item xs={2}>
                  <Typography className="text-14 font-semibold m-0">
                    PDF Page Number:
                  </Typography>
                </Grid>
                <Grid item xs>
                  <Typography className="text-14 m-0">
                    {data.question.pdf_page}
                  </Typography>
                </Grid>
              </Grid>
            )} */}
          </Grid>
        </Paper>

        <Paper elevation={0} variant="outlined" square className="p-16 m-16">
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Typography className="text-14 font-bold m-0">Lures:</Typography>
              <Divider className="my-16" />
              <Grid container spacing={0}>
                {data.question.lures.map((lure, index) => (
                  <Grid key={lure.lure_text} item xs={12}>
                    {index > 0 && <Divider className="my-0" />}
                    <Grid container spacing={1} columns={24}>
                      <Grid item xs={4}>
                        {lure.is_correct ? (
                          <Grid container direction="row">
                            <Typography className="text-14 font-semibold m-0">
                              Correct
                            </Typography>
                            <BASESvgIcon
                              className="text-green-600 mx-2"
                              size={20}
                            >
                              heroicons-solid:check-circle
                            </BASESvgIcon>
                            <Typography className="text-14 font-semibold m-0">
                              Lure:
                            </Typography>
                          </Grid>
                        ) : (
                          <Grid container direction="row">
                            <Typography className="text-14 font-semibold m-0">
                              Incorrect
                            </Typography>
                            <BASESvgIcon
                              className="text-red-600 mx-2"
                              size={20}
                            >
                              heroicons-solid:x-circle
                            </BASESvgIcon>
                            <Typography className="text-14 font-semibold m-0">
                              Lure:
                            </Typography>
                          </Grid>
                        )}
                      </Grid>
                      <Grid item xs>
                        <Typography className={`${tl} m-0`} dir={dir}>
                          {lure.lure_text}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                ))}
              </Grid>
            </Grid>
          </Grid>
        </Paper>

        <Paper elevation={0} variant="outlined" square className="p-16 m-16">
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Grid container spacing={0}>
                <Grid item xs={12}>
                  <Typography className="text-14 font-bold m-0">
                    Question Options:
                  </Typography>
                  <Divider className="my-16" />
                </Grid>
                <Grid item xs={2} className="text-14 font-semibold m-0">
                  Multiple Select:
                </Grid>
                <Grid item xs={10}>
                  <Typography className="text-14 m-0">
                    {data.question.multi_select ? "true" : "false"}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Paper>
      </Paper>
    </div>
  );
}
